import { render } from "./App.vue?vue&type=template&id=b22ec23c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b22ec23c&lang=css"
script.render = render

export default script